<div id="banner-container" *ngIf="mayViewBanner && activeBanner">
    <div class="banner-contents">
      <p class="titillium-web">{{bannerMessage}}</p>
    </div>
</div>